/** Reporting coverage only. Payment execution has a separate, stricter freshness check. */
export function availableCashCoverage(
  accounts: Array<{
    available?: number | null;
    bankObservedAt?: string | null;
  }>,
  now: number,
  maximumAgeMs = 75 * 60 * 1000,
) {
  const covered = accounts.filter((account) => {
    const observed = account.bankObservedAt
      ? Date.parse(account.bankObservedAt)
      : NaN;
    return (
      typeof account.available === "number" &&
      Number.isFinite(account.available) &&
      Number.isFinite(observed) &&
      observed <= now &&
      now - observed <= maximumAgeMs
    );
  });
  return {
    coveredCount: covered.length,
    total:
      accounts.length > 0 && covered.length === accounts.length
        ? covered.reduce((sum, account) => sum + account.available!, 0)
        : null,
  };
}
